import { Globe } from "lucide-react";
import FilterSelect from "./FilterSelect";

// Desktop filter row — labels per the V2 handoff (boards 1a/1b):
// "Country / Jurisdiction", "Specialization", "Language", "City / HQ".
// The handoff draws the country label with a literal 🌍 character
// (SPEC-SYMBOLS #19), but the platform renders glyphs as icons, never emoji —
// the same rule lawyerFlag.js states for the country flags ("the design uses
// emoji; the platform uses flag-icons"). So the globe is the Lucide icon,
// matching the SVG chevron/search glyphs this row already uses (T050-1).
// Country/jurisdiction is the hero filter (searchable, with flags, and
// MULTI-select per follow-up pack A2 — board 1l's checkboxes);
// specialization, language and city follow as single-selects. Options come
// from the facet lists derived in useLawyers.
const LawyerFilterBar = ({
  facets,
  filters,
  setFilter,
  jurisdictionFlags = {},
  t = (s) => s,
}) => (
  <div className="hidden md:flex flex-wrap items-center gap-2.5">
    <FilterSelect
      label={t("Country / Jurisdiction")}
      icon={<Globe size={13} className="flex-none" />}
      value={filters.jurisdiction}
      options={facets.jurisdictions}
      onChange={(v) => setFilter("jurisdiction", v)}
      withFlags
      searchable
      multi
      flagOptions={jurisdictionFlags}
    />
    <FilterSelect
      label={t("Specialization")}
      value={filters.specialization}
      options={facets.specializations}
      onChange={(v) => setFilter("specialization", v)}
    />
    <FilterSelect
      label={t("Language")}
      value={filters.language}
      options={facets.languages}
      onChange={(v) => setFilter("language", v)}
    />
    <FilterSelect
      label={t("City / HQ")}
      value={filters.city}
      options={facets.cities}
      onChange={(v) => setFilter("city", v)}
      searchable
    />
  </div>
);

export default LawyerFilterBar;
